import './App.css';
import Body from './component/Body/Body';
import Header from './component/Header/Header';


function App() {
    return (
        <div className="App">
            <Header></Header>
            <Body></Body>
        </div>
    );
}

export default App;

